import React from 'react';
import AddTeamEventPage from './AddTeamEventPage';

const EditTeamEventPage = () => <AddTeamEventPage variant="edit" />;

export default EditTeamEventPage;
